Object.defineProperty(exports, "__esModule", {
  value: true
});
var b = require("/app/node_modules/koa-rpc-call/browser");
var o = exports['default'] = {};
o["list"] = b.createRpcProxy("ContentCalendarApi", "list", {
  "urlPrefix": "/rpc",
  httpMethod: 'GET'
});
o["get"] = b.createRpcProxy("ContentCalendarApi", "get", {
  "urlPrefix": "/rpc",
  httpMethod: 'GET'
});
o["save"] = b.createRpcProxy("ContentCalendarApi", "save", {
  "urlPrefix": "/rpc"
});
o["remove"] = b.createRpcProxy("ContentCalendarApi", "remove", {
  "urlPrefix": "/rpc"
});
o["listParticipants"] = b.createRpcProxy("ContentCalendarApi", "listParticipants", {
  "urlPrefix": "/rpc",
  httpMethod: 'GET'
});